const widgetName = 'socialNetworkWidgetDefault';
let initialized = false;

function initialize() {

  $(`#socialNetworkWidgetDefault`).append('<div class="socialTabContainer"></div>');


  $(`#socialNetworkWidgetDefault`).on('click', '.socialNetworkTabDefault', function () {
    let tab = $(this).attr('data-social-network-tab');

    $('.socialNetworkTabDefault').removeClass('activeTab');
    $('.socialFeedContainerDefault').hide();

    $(this).addClass('activeTab');
    $(`#${tab}Container`).show();

  });

  initialized = true;

}


function isCurrent(current, widget) {
  if (current) {
    $(`#socialNetworkWidgetDefault #${widget}Tab`).addClass('activeTab');
    $(`#socialNetworkWidgetDefault #${widget}Container`).show();
  }
}


// INSTAGRAM -----------

function instafeed() {

  const instafeedTab = `
        <a id="instafeedTab" class="socialNetworkTabDefault" data-social-network-tab="instafeed">
          <svg class="circle" xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24">
            <title>Instagram Tab Icon</title>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"/>
            <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z"/>
          </svg>
        </a>
      `;
  const instafeedContainer = '<div id="instafeedContainer" class="socialFeedContainerDefault" style="display: none;"></div>';

  if (!initialized) {
    initialize();
  }

  $(`#socialNetworkWidgetDefault .socialTabContainer`).append(instafeedTab);
  $(`#socialNetworkWidgetDefault`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer'
  });
  feed.run();



}

// FACEBOOK -----------
let fbHeight = "0"
let windowSize = window.innerWidth;
let fbkUrl = "";
$(document).ready(function () {
  fbkUrl = $('.footer .socialNetworks .socialNetworkIconFacebook').attr('href');
})

if ($('body').hasClass('saffireMobileSize') || windowSize <= 800) {
  fbHeight = "460" // Value to be changed depending on design
} else {
  fbHeight = "570" // Value to be changed depending on design
}
const fbWidth = 500; // Can be as it is right now
function facebookfeed(current) {

  const facebookfeedTab = `
          <a id="facebookfeedTab" class="socialNetworkTabDefault activeTab" data-social-network-tab="facebookfeed">
            <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" class="circle" >
              <title>Facebook Tab Icon</title>
              <g id="Facebook_Tab_Icon" data-name="Facebook_Tab_Icon">
                <path d="M12.001 2.002c-5.522 0-9.999 4.477-9.999 9.999 0 4.99 3.656 9.126 8.437 9.879v-6.988h-2.54v-2.891h2.54V9.798c0-2.508 1.493-3.891 3.776-3.891 1.094 0 2.24.195 2.24.195v2.459h-1.264c-1.24 0-1.628.772-1.628 1.563v1.875h2.771l-.443 2.891h-2.328v6.988C18.344 21.129 22 16.992 22 12.001c0-5.522-4.477-9.999-9.999-9.999z"/>
            </svg>
          </a>
        `;
  const facebookfeedContainer = `
        <div id="facebookfeedContainer" class="socialFeedContainerDefault" >
          <div class="fb-page" data-href="${fbkUrl}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
            <div class="fb-xfbml-parse-ignore">
              <blockquote cite="${fbkUrl}"><a href="${fbkUrl}">Loading...</a></blockquote>
            </div>
          </div>
        </div>
      `;

  isCurrent(current, 'facebookfeed');
  if (!initialized) {
    initialize();
  }

  let title = "Central States Fair";
  if ($('body').hasClass('saffireMobileSize') || windowSize <= 1200) {
    title = "Let’s get social";
  }

  $(`#socialNetworkWidgetDefault .socialTabContainer`).append(`<h3 class="social-header" aria-label="${title}">${title}</h3>`);
  $(`#socialNetworkWidgetDefault .socialTabContainer`).append(facebookfeedTab);
  $(`#socialNetworkWidgetDefault`).append(facebookfeedContainer);
}


export { facebookfeed, instafeed };